import { IComponentOptions } from "angular";
import { MachinesEditFormController } from "./controller";

export const vsComponentName = "machineEditForm";

export const machineEditFormComponentOptions: IComponentOptions = {
  controller: MachinesEditFormController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    model: "<",
    machineFieldsEditable: "<",
    onSubmit: "<",
    onCancel: "<",
    formTitle: "<",
    progressiveDefinition: "<",
  },
};
